var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "h2",
    { staticClass: "title", style: { color: _vm.person.colors.title } },
    [
      _c("strong", [_vm._v(_vm._s(_vm.person.firstname))]),
      _vm._v(" "),
      _c("span", { staticClass: "subtitle" }, [
        _vm._v(_vm._s(_vm.person.title)),
      ]),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }